import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown, faChevronUp, faSortUp, faSortDown, faFlask,faX, faPaperclip, faPlus, faPen, 
  faMobileAndroidAlt, faSave, faTimes,
  faEdit,faCoins,faTag, faPercent, faTags  
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import '../Css/Tooltip.css';
import { Loader, Spinner } from '../Loader/Loader';
import DiscountRulesEngine from './DiscountRulesEngine';
import { decryptData } from '../../utils/storageCrypto';

// Custom Select Components (minimal version from rules engine UI style - FIXED for fixed width/no wrap)
const Select = ({ children, value, onValueChange, placeholder = "Select option" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelect = (newValue) => {
    setSelectedValue(newValue);
    if (onValueChange) onValueChange(newValue);
    setIsOpen(false);
  };

  return (
    <div className="relative min-w-[200px]">  {/* FIXED: Fixed min-width to fit longest text */}
      <SelectTrigger onClick={() => setIsOpen(!isOpen)} value={selectedValue} placeholder={placeholder} />
      {isOpen && (
        <SelectContent>
          {React.Children.map(children, (child, index) => {
            if (child && child.type === SelectItem) {
              return React.cloneElement(child, { 
                key: child.key || index,
                onSelect: handleSelect,
                isSelected: child.props.value === selectedValue
              });
            }
            return child;
          })}
        </SelectContent>
      )}
    </div>
  );
};

const SelectTrigger = ({ children, onClick, value, placeholder }) => {
  const displayValue = value ? 
    React.Children.toArray(children).find(child => child.props.value === value)?.props.children || value 
    : placeholder;

  return (
    <button
      type="button"
      className="w-full px-3 py-2 text-sm bg-gray-50 border border-gray-200 rounded-md focus:bg-white focus:ring-2 focus:ring-[#f7525a]/20 focus:outline-none transition-all duration-200 flex items-center justify-between hover:bg-gray-100"
      onClick={onClick}
    >
      <span className={`${value ? "text-gray-900" : "text-gray-400"} whitespace-nowrap overflow-hidden text-ellipsis`}>  {/* FIXED: No wrap, ellipsis if too long */}
        {displayValue}
      </span>
      <FontAwesomeIcon icon={faChevronDown} className="text-gray-400 text-xs ml-2 flex-shrink-0" />  {/* FIXED: Prevent icon shrink */}
    </button>
  );
};

const SelectContent = ({ children }) => (
  <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-48 overflow-y-auto min-w-[200px]">  {/* FIXED: Match min-width */}
    <div className="py-1">{children}</div>
  </div>
);

const SelectItem = ({ children, value, onSelect, isSelected }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onSelect) onSelect(value);
  };

  return (
    <button
      type="button"
      className={`w-full px-3 py-2 text-sm text-left hover:bg-gray-100 focus:bg-gray-100 focus:outline-none transition-colors whitespace-nowrap ${
        isSelected 
          ? 'bg-gray-100 text-[#f7525a] font-medium'  // FIXED: Red text only, subtle bg highlight, bold for emphasis
          : 'text-gray-900'
      }`}
      onClick={handleClick}
    >
      {children}
    </button>
  );
};

const DiscountRulesList = () => {
  const navigate = useNavigate();
  const [discountRules,setDiscountRules] = useState([]);
  const [selectedRule, setSelectedRule] = useState(null);
  const [ruleId, setRuleId] = useState(null);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  console.log(backendApiUrl);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const RETRY_LIMIT = 3;
  const [retryCount, setRetryCount] = useState(0);
  const [mappedRules,setMappedRules] = useState([]);
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [showComponent, setShowComponent] = useState('none'); // 'none', 'edit', 'create'
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

useEffect(() => {
    fetchDiscountRules();
}, []);

const fetchDiscountRules = async (attempt = 1) => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
          const token = decryptData(encryptedToken);
      const encryptedHubId = sessionStorage.getItem('hubId');
      const hubId = decryptData(encryptedHubId);    
      const response = await fetch(fetchUrl + "discounts/get-all-rules?hubId=" + hubId, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      });
      const data = await response.json();
      
      console.log(data?.data)
      if (data?.data) {
      setDiscountRules(data?.data);  
      setMappedRules(data?.data);

      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchDiscountRules(attempt + 1), 1000); // Retry after 1 second
      } else {
       
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchDiscountRules(attempt)); // Set retry function
      }
    }finally {
      setIsLoading(false);
    }
  };

  const handleRuleClick = (rule) => {
  if (ruleId === rule._id) {
    // If clicked rule is already selected, unselect it
    setRuleId(null);
    setSelectedRule(null);
    setShowComponent('none');
  } else {
    // Otherwise, select the rule
    setRuleId(rule._id);
    setSelectedRule(rule);
    setShowComponent('none'); // Only selection; edit happens explicitly
  }
};

const handleCreateRule = () => {
  const rule = { empty: true, type: 'discount' };
  setSelectedRule(rule);
  setRuleId(null);
  setShowComponent('create');
};

  const handleEditRule = () => {
    setShowComponent('edit');
  }



  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="bg-white flex flex-row w-full h-full overflow-hidden">
      {/* List of rules Div start */}
      <div className="flex flex-col w-[24%] h-full border-r overflow-hidden">
        <div className="p-2 border-b py-2 flex flex-row justify-between flex-shrink-0">
        <div className="flex-1 mr-3">
        <input
            type="text"
            placeholder="Search rules..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#f7525a] focus:border-transparent"
        />
        </div>
          <div className='flex gap-4'>
            <button
              onClick={handleEditRule}
              disabled={!selectedRule}
              className={`py-1 px-2 rounded-md transition-colors ${
                selectedRule
                  ? 'bg-[#f7525a] text-white hover:bg-green-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
              data-tooltip="Edit Rule"
              title=""
              style={{ '--tooltip-bg': 'black' }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </button>

            <button
              className="mr-2 bg-[#f7525a] py-1 px-2 text-white rounded-md hover:bg-green-700 transition-colors"
              data-tooltip="Create Rule"
              title=""
              style={{ '--tooltip-bg': 'black' }}
              onClick={handleCreateRule}
            >
              <FontAwesomeIcon icon={faPlus} className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />
            </button>
          </div>
        </div>
        
{/* Rules List - Independent Scrolling */}
<div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
  <div className='flex flex-col'>
    {/* Filter rules based on selectedFilter */}
    {(() => {
    const filteredRules = mappedRules.filter((rule) => {
    const criteriaName = rule?.criteria?.[0]?.name?.toLowerCase() || '';
    const ruleName = rule?.rules?.[0]?.name?.toLowerCase() || '';
    const search = searchTerm.toLowerCase();

    return (
        criteriaName.includes(search) ||
        ruleName.includes(search)
    );
    });

      if (filteredRules.length === 0) {
        return (
          <div className="p-4 text-center text-gray-500 text-sm">
          {selectedFilter === "all"
            ? "No rules found."
            : `No ${selectedFilter} rules found.`}
          </div>
        );
      }

      return filteredRules.map((rule) => (
        <div 
          key={rule._id} 
          onClick={() => handleRuleClick(rule)} 
          className={`border-b text-sm flex items-center px-4 py-2 ${ruleId === rule._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}
        >
          <div className='flex flex-row'>
            <div>
              <input 
                type="checkbox" 
                className="mr-2 border border-gray-400 shadow-sm hover:shadow-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-600 rounded" 
                checked={ruleId === rule._id} 
                readOnly
              />
            </div>
            <div className='flex flex-col'>
              <p className='text-sm font-semibold'>{rule?.criteria[0]?.name || 'Unnamed Criteria'}</p>
              <p className="text-gray-600 text-sm">{rule?.rules[0]?.name || 'Unnamed Rule'}</p>
{/*               <p className="text-xs text-[#f7525a]">
                Discount Rule
              </p> */}
            </div>
          </div>
        </div>
      ));
    })()}
  </div>
</div>
      </div>
      {/* List of rules Div end */}

{/* Rule Builder/Editor Section - Independent Scrolling */}
<div className="flex-1 h-full border-l flex flex-col overflow-hidden">
  {showComponent === 'create' && selectedRule && (
    <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
      <DiscountRulesEngine 
        mode="create" 
        type={selectedRule.type}  // Pass the selected type
      />
    </div>
  )}
  {showComponent === 'edit' && selectedRule && (
    <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
      <DiscountRulesEngine 
        mode="edit" 
        existingRuleData={selectedRule}
        ruleId={ruleId}
        criteriaId={selectedRule.criteria?._id}
        type={selectedRule.type || 'discount'}
      />
    </div>
  )}
  {showComponent === 'none' && (
    <div className="flex justify-center items-center h-full bg-gray-50">
      <div className="text-center">
        <div className="mb-4">
          <FontAwesomeIcon 
            icon={faPlus} 
            className="text-6xl text-gray-300 mb-4" 
          />
        </div>
        <p className="text-gray-500 text-lg mb-2">No rule selected</p>
        <p className="text-gray-400 text-sm">Select a rule to edit or create a new rule</p>
        <button
          onClick={handleCreateRule}
          className="mt-4 bg-[#f7525a] text-white px-2 py-1 rounded-md hover:bg-[#e6474f] transition-colors"
        >
          <FontAwesomeIcon icon={faPlus} className="mr-2" />
          Create New Rule
        </button>
      </div>
    </div>
  )}
</div>
    </div>
  );
}
  
export default DiscountRulesList;